import Vue from 'vue';
import Vuetify from 'vuetify/lib';
// Translation provided by Vuetify (typescript)
import es from 'vuetify/src/locale/es.ts'

Vue.use(Vuetify);

export default new Vuetify({
    lang: {
        locales: { es },
        current: 'es',
      },
});
